exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3gi8RFSqimzVVN{background-color:#ebecf0;border-radius:4px;color:#6b778c;height:24px;justify-content:center;padding:8px}._3gi8RFSqimzVVN,._32zvn7hBOkvPls{align-items:center;display:flex;margin:-8px 8px 40px}._32zvn7hBOkvPls{border-top:1px solid #ebecf0;flex-direction:column;padding:16px}._1XZuujGfKTmflR{display:block}.WBsd9FQE6XUNNt{font-size:16px;font-weight:700;margin-top:12px}._1m0e6Cmgmi_jNr{color:#6b778c}", ""]);

// exports
exports.locals = {
	"empty": "_3gi8RFSqimzVVN",
	"emptyToday": "_32zvn7hBOkvPls",
	"image": "_1XZuujGfKTmflR",
	"title": "WBsd9FQE6XUNNt",
	"subtitle": "_1m0e6Cmgmi_jNr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-cards-due-empty.less
// module id = rnll
// module chunks = 24